import * as style from '../ButtonDispatcher.module.css';

export const determinePosition = (webSettings = {}, isMobile) => {
  const {
    bottom,
    left = false,
    right,
    top = false,
    bottomMobile,
    leftMobile = false,
    rightMobile,
    topMobile = false,
  } = webSettings;
  const mobile = { bottom: bottomMobile, left: leftMobile, right: rightMobile, top: topMobile };
  const desktop = { bottom, left, right, top };
  const { bottom: finalBottom, left: finalLeft, right: finalRight, top: finalTop } = isMobile ? mobile : desktop;

  return {
    className: [finalLeft ? style.left : style.right, finalTop ? style.top : style.bottom],
    style: {
      top: finalTop >= 1 ? finalTop : undefined,
      bottom: finalBottom >= 1 ? finalBottom : undefined,
      left: finalLeft >= 1 ? finalLeft : undefined,
      right: finalRight >= 1 ? finalRight : undefined,
    },
  };
};
